export default __webpack_public_path__ + "static/media/logo.39cddaf4.png";